export function getReverseGeocodeCoordinates(location: {
  latitude?: number | null;
  longitude?: number | null;
}): { lat: number; lon: number } | null {
  const lat = location.latitude;
  const lon = location.longitude;

  if (lat == null || lon == null || !lat || !lon) {
    return null;
  }

  return { lat, lon };
}

export function buildNominatimReverseUrl(
  lat: number,
  lon: number,
  basePath = "/api/nominatim/reverse"
): string {
  return `${basePath}?format=jsonv2&lat=${lat}&lon=${lon}`;
}
